import React, { useContext } from 'react'
import styled, { css } from 'styled-components'
import { LayoutContext } from '../../contexts'

const BreadCrumb = ({ children }) => {
  const { node_locale } = useContext(LayoutContext)

  // return <div useUnderline={node_locale === 'en-US'}>{children}</div>
  return (
    <BreadCrumbWrapper useUnderline={node_locale === 'en-US'}>
      {children}
    </BreadCrumbWrapper>
  )
}

const BreadCrumbWrapper = styled.div`
  text-transform: lowercase;
  letter-spacing: 0.05em;

  ${({ useUnderline }) =>
    useUnderline &&
    css`
      a {
        text-decoration: underline;
      }
    `}
`

export default BreadCrumb
